
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
// import regular from "@/common/regular";
import {} from "@/api/api-basic";
import i18n from "@/config/i18n";

@Component({
  components: {}
})
export default class PiDetailsReportFile extends Vue {
  private modalShow = false;
  private modalTitle = i18n.t("details");
  private loading = false;
  private formInline: objAny = {
    brandName: "",
    busLicenseNumber: "",
    contactName: "",
    legalIdCard: "",
    legalPerson: "",
    manufacturerId: "",
    manufacturerName: "",
    manufacturerPkId: "",
    phoneNo: "",
    deviceModel: ""
  };

  private isAdd = true;
  private itemData: objAny = {};

  open(itemData: objAny) {
    this.modalShow = true;
    this.formInline = itemData;
  }
  closeModal() {
    this.modalShow = false;
  }
}
